var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.3333 6.50768V13.491C18.3333 15.8327 17.2583 17.441 15.3667 18.0493C14.8167 18.241 14.1833 18.3327 13.4917 18.3327H6.50833C5.81666 18.3327 5.18333 18.241 4.63333 18.0493C2.74166 17.441 1.66666 15.8327 1.66666 13.491V6.50768C1.66666 3.47435 3.475 1.66602 6.50833 1.66602H13.4917C16.525 1.66602 18.3333 3.47435 18.3333 6.50768Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3667 18.0509C14.8167 18.2426 14.1833 18.3343 13.4917 18.3343H6.50833C5.81666 18.3343 5.18333 18.2426 4.63333 18.0509C4.925 15.8509 7.225 14.1426 10 14.1426C12.775 14.1426 15.075 15.8509 15.3667 18.0509Z",
    fill: "#FCFCFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9833 9.64936C12.9833 11.2994 11.65 12.641 10 12.641C8.35 12.641 7.01666 11.2994 7.01666 9.64936C7.01666 7.99936 8.35 6.66602 10 6.66602C11.65 6.66602 12.9833 7.99936 12.9833 9.64936Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSquare);
export default __webpack_public_path__ + "static/media/user-square.00fda2edeae2f419e3c2ad721a1c5794.svg";
export { ForwardRef as ReactComponent };